<style lang='scss' scoped>
.myCloud {
  position: relative;
  padding-top: 2.51rem;
  .sort {
    position: fixed;
    width: calc(100% - 0.64rem);
    background: #fff;
    z-index: 998;
    font-size: 0.28rem;
    height: 0.74rem;
    background-color: #f7f7f7;
    line-height: 0.74rem;
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    padding: 0rem 0.32rem;
    .sort_boxL {
      height: 0.74rem;
      line-height: 0.74rem;
      img {
        width: 0.22rem;
        vertical-align: middle;
      }
      div {
        margin-left: 0.1rem;
      }
    }
    .sort_boxR {
      height: 0.74rem;
      line-height: 0.74rem;
      img {
        
        width: 0.28rem;
        vertical-align: middle;
      }
      div {
        color: #666;
        margin-top: 0.02rem;
        margin-left: 0.1rem;
      }
    }
  }
  .selectType {
    top: 1.63rem;
    position: fixed;
    ul {
      background-color: #f7f7f7;
      overflow: scroll;
      width: 7.5rem;
      padding: 0px 0.32rem;
      white-space: nowrap;
      height: 0.8rem;
      line-height: 0.8rem;

      li {
        color: #666666;
        display: inline-block;
        margin-right: 0.5rem;
        min-width: 0.5rem;
        max-width: 2.5rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        font-size: 0.28rem;
      }
      li.active {
        color: #0497ff;
      }
    }
  }
  .codeData {
    padding-bottom: 2rem;
    li {
      margin-top: 0.3rem;
      margin-left: 3.46%;
      width: 44.26%;
      height:4.18rem;
      border: 1px solid #e6e9ed;
      .img_box {
        // width: 2.92rem;
        height: 2.48rem;
        line-height: 2.48rem;
        border-top-right-radius: 0.05rem;
        border-top-left-radius: 0.05rem;
        padding: 0.2rem;
        text-align: center;
        background-color: #e6e9ed;
        img {
          vertical-align: middle;
          border-radius: 0.1rem;
          max-width: 87.95%;
          // max-width: 2.92rem;
          max-height: 2.48rem;
        }
      }
      .codeInfo {
        padding: 0.2rem 0.32rem 0.24rem 0.32rem;
        p {
          font-size: 0.28rem;
          margin-bottom: 0.2rem;
        }
        div.m_clearLR {
          font-size: 0.24rem;
          line-height: 0.24rem;
          color: #9a9a9a;
        }
        .myCloudDate {
          margin-right: 0.35rem;
          font-size: 0.24rem;
          color: #999999;
        }
      }
    }
  }
  .noData {
    width: 100%;
    top: 4.47rem;
    text-align: center;
    position: absolute;
    img {
      width: 1.99rem;
    }
    .text {
      font-size: 0.28rem;
      color: #666666;
      margin-top: 0.6rem;
    }
    .feedback {
      margin-top: 0.6rem;
      width: 2.25rem;
      height: 0.72rem;
      line-height: 0.72rem;
      font-size: 0.3rem;
      text-align: center;
      color: #0497ff;
      border: 1px solid #0497ff;
      border-radius: 0.05rem;
    }
  }
  .selectSort {
    position: fixed;
    top: 3.15rem;
    z-index: 1002;
  }
  .searchBack {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
    height: 0.64rem;
    line-height: 0.64rem;
    padding: 0.12rem 0px;
    background-color: #0497ff;

    display: flex;
    input {
      width: 5.2rem;
      height: 0.64rem;
      border-radius: 0.05rem;
      border: none;
      flex: 1;
      padding-left: 0.2rem;
      margin-right: 10px;
      outline: none;
      font-size: 0.3rem;
      background-color: #fff;
    }
    img {
      margin-top: 0.12rem;
      margin-right: 0.38rem;
      width: 0.19rem;
      height: 0.38rem;
      margin-left: 0.3rem;
    }
    .confirm {
      font-size: 0.32rem;
      color: #fff;
      margin-right: 0.3rem;
    }
  }
  .myhead {
    position: fixed;
    background-color: #fff;
    top: 0.88rem;
    width: 5.5rem;
    z-index: 999;
  }
  .cloudShare {
    overflow: hidden;
    width: 100%;
    text-align: center;
    .line {
      height: 5px;
      margin-top: -5px;
      box-shadow: 0 4px 4px #f0f2f4;
    }
    img {
      margin-top: 1.47rem;
      width: 2.02rem;
    }
    .text {
      font-size: 0.28rem;
      color: #666666;
      margin-top: 0.55rem;
    }
  }
  .noDataTextEmpty {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: .5rem;
    color: #666;
    font-size: 0.28rem;
    padding-bottom: 0.5rem;
    img {
      width: 1.99rem;
    }
    div {
      margin-top: 0.5rem;
    }
  }
  .noDataText {
    text-align: center;
    margin-top: 0.5rem;
    color: #666;
    font-size: 0.28rem;
    padding-bottom: 0.5rem;
  }
  .noLogin {
    width: 100%;
    top:4.07rem;
    text-align: center;
    position: absolute;
    img {
      width: 3.5rem;
    }
    .text {
      font-size: 0.28rem;
      color: #666666;
      margin-top: 0.3rem;
    }
    .feedback {
      margin-top: 0.6rem;
      width: 2.25rem;
      height: 0.72rem;
      line-height: 0.72rem;
      font-size: 0.3rem;
      text-align: center;
      color: #0497ff;
      border: 1px solid #0497ff;
      border-radius: 0.05rem;
    }
  }
  .codeList {
    margin: 0rem 0 0 0.32rem;
    li {
      padding-top: 0.15rem;
      display: flex;
      & .listDiv {
        text-align: center;
        width: 1.16rem;
        height: 1.16rem;
        background-color: #e6e9ed;
        line-height: 1.1rem;
      }
      & .listDiv > img {
        vertical-align: middle;
        max-width: 90%;
        max-height: 90%;
      }
      .info {
        border-bottom: 1px solid #e6e6e6;
        margin-top: 0.25rem;
        margin-left: 0.25rem;
        height: 1.05rem;
        flex: 1;
        img {
          margin-top: 0.15rem;
          margin-right: 0.32rem;
          width: 0.36rem;
        }
        p {
          max-width: 5rem;
          font-size: 0.28rem;
          color: #333;
          line-height: 0.28rem;
          margin-bottom: 0.15rem;
        }
        span {
          color: #9a9a9a;
          font-size: 0.24rem;
          margin-right: 0.35rem;
        }
      }
    }
  }
  .hiddenBox{
      position: fixed;
      top:0px;
      right: 0px;
      left:0px;
      bottom:0px;
      z-index: 1001;
      background-color: transparent;
    }
}
</style>
<template>
  <div class="myCloud">
     <div class="whiteBoxSearch"></div>
    <div class="hiddenBox" @touchstart="touchHidden" v-show="showSort" @click="closeHidden"></div>
    <div class="searchBack m_clearLR">
      <img src="@/../public/images/back.png" @click="toCloudback" class="m_floatL" />
      <input
        type="text"
        :placeholder="searchText"
        autofocus="autofocus"
        maxlength="20"
        v-model="tempName"
        @keyup.enter="confirm"
        class="m_floatL"
      />
      <div class="confirm m_floatR zhen_21" @click="confirm">{{_lang[$route.query.type].zhen_16}}</div>
    </div>
    <myHead @searchType="searchType" class="myhead"></myHead>
    <div class="sort m_clearLR" v-if="pathType=='myCloud'">
      <div class="sort_boxL m_clearLR m_floatL" @click="openSort">
        <img src="@/../public/images/small.png" alt :class="sort==2||sort==4||sort==6?'rotate180':''" />
        <div class="m_floatR">{{sortName}}</div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR" v-if="changeList" @click="changeStyle">
        <img src="@/../public/images/list.png" alt class />
        <div class="m_floatR zhen_22">
          {{_lang[$route.query.type].zhen_1}}
          <span id="tests"></span>
        </div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR" v-else @click="changeStyle">
        <img src="@/../public/images/list_2.png" alt class />
        <div class="m_floatR zhen_23">{{_lang[$route.query.type].zhen_2}}</div>
      </div>
    </div>
    <selectSort class="selectSort" v-show="showSort" @selectSort="selectSort"></selectSort>
    <ul class="codeData m_clearLR" v-if="!isShare" v-show="changeList">
      
      <li
        class="m_floatL"
        v-for="(item,index) in cloudData"
        :key="index"
        @click="selectTypeTag(item)"
      >
        <div class="img_box">
          <img :src="item.img" alt />
        </div>
        <div class="codeInfo">
          <p class="textLine">{{item.name}}</p>
          <div class="m_clearLR">
            <div
              class="m_floatL myCloudDate"
              v-if="pathType=='myCloud'"
            >{{item.addTime|partFilter('')}}</div>
            <div class="size m_floatL" v-if="pathType=='myCloud'">{{item.width+'x'+item.height}}</div>
            <div class="size m_floatL" v-else>{{item.fileWidth+'x'+item.fileHeight}}</div>
          </div>
        </div>
      </li>
    </ul>
    <div class="cloudShare" v-else>
      <div class="line"></div>
      <img src="@/../public/images/loading.png" alt />
      <div class="text zhen_26">{{_lang[$route.query.type].zhen_6}}</div>
    </div>

    <ul class="codeList" v-show="!changeList">
      <li class="m_clearLR" v-for="(item,index) in cloudData" :key="index" @click="selectTag(item)">
        <div class="listDiv m_floatL">
          <img :src="item.img" />
        </div>
        <div class="m_floatL info">
          <div class="m_floatL">
            <p class="textLine">{{item.name}}</p>
            <span>{{item.addTime|partFilter('')}}</span>
            <span>{{item.width+'x'+item.height}}</span>
          </div>
          <!-- <div class="m_floatR"   @click="selectList(item)">
            <img v-if="!item.select" class="editImg" src="@/../public/images/select.png" alt="">
            <img v-else  class="editImg" src="@/../public/images/selected.png" alt="">
          </div>-->
        </div>
      </li>
    </ul>
    <div v-show="noData" class="noData">
      <img src="@/../public/images/noData.png" />
      <div class="text">
        <span class="zhen_24">{{_lang[$route.query.type].zhen_21}}</span>
        “{{search}}”
        <span class="zhen_25">{{_lang[this.$route.query.type].zhen_22}}</span>
      </div>
      <div
        class="feedback m_tran50 zhen_25"
        @click="feedbackButton"
      >{{_lang[$route.query.type].zhen_17}}</div>
    </div>
    <div v-show="noDataCloud" class="noData">
      <img src="@/../public/images/noData.png" />
      <div class="text">
        <span class="zhen_24">{{_lang[$route.query.type].zhen_21}}</span>
        “{{search}}”
        <span class="zhen_25">{{_lang[this.$route.query.type].zhen_35}}</span>
      </div>
    </div>
    <div class="noDataText zhen_27" v-show="noDataText">
      <div>{{_lang[$route.query.type].zhen_5}}</div>
    </div>
    <div class="noDataTextEmpty zhen_27" v-show="noDataTextEmpty">
      <img src="@/../public/images/noData.png" />
      <div>{{_lang[$route.query.type].zhen_5}}</div>
    </div>
    <div v-show="noLogin" class="noLogin">
      <img src="@/../public/images/noLogin.png" />
      <div class="text zhen_28">{{_lang[$route.query.type].zhen_7}}</div>
      <div class="feedback m_tran50 zhen_29" @click="toLogin">{{_lang[$route.query.type].zhen_15}}</div>
    </div>
  </div>
</template>

<script>
import { lang } from "@/utils/i18n";
import qs from 'qs';
import JSEncrypt from "jsencrypt";
import jsSha256 from "js-sha256";
import CryptoJS from "crypto-js";
import myHead from "@/components/head";
import {GetQueryString} from '@/../public/js/main.js'
import selectSort from "@/components/selectSort";
import { DlabelTemplateSelect, TemplateCategory, searchCloundList ,cloundList} from "@/api/api";
var bridge = {
  default: this,
  call: function(b, a, c) {
    var e = "";
    "function" == typeof a && ((c = a), (a = {}));
    a = { data: void 0 === a ? null : a };
    if ("function" == typeof c) {
      var g = "dscb" + window.dscb++;
      window[g] = c;
      a._dscbstub = g;
    }
    a = JSON.stringify(a);
    if (window._dsbridge) e = _dsbridge.call(b, a);
    else if (window._dswk || -1 != navigator.userAgent.indexOf("_dsbridge"))
      e = prompt("_dsbridge=" + b, a);
    return JSON.parse(e || "{}").data;
  },
  register: function(b, a, c) {
    c = c ? window._dsaf : window._dsf;
    window._dsInit ||
      ((window._dsInit = !0),
      setTimeout(function() {
        bridge.call("_dsb.dsinit");
      }, 0));
    "object" == typeof a ? (c._obs[b] = a) : (c[b] = a);
  },
  registerAsyn: function(b, a) {
    this.register(b, a, !0);
  },
  hasNativeMethod: function(b, a) {
    return this.call("_dsb.hasNativeMethod", { name: b, type: a || "all" });
  },
  disableJavascriptDialogBlock: function(b) {
    this.call("_dsb.disableJavascriptDialogBlock", { disable: !1 !== b });
  }
};
!(function() {
  if (!window._dsf) {
    var b = {
        _dsf: { _obs: {} },
        _dsaf: { _obs: {} },
        dscb: 0,
        dsBridge: bridge,
        close: function() {
          bridge.call("_dsb.closePage");
        },
        _handleMessageFromNative: function(a) {
          var e = JSON.parse(a.data),
            b = { id: a.callbackId, complete: !0 },
            c = this._dsf[a.method],
            d = this._dsaf[a.method],
            h = function(a, c) {
              b.data = a.apply(c, e);
              bridge.call("_dsb.returnValue", b);
            },
            k = function(a, c) {
              e.push(function(a, c) {
                b.data = a;
                b.complete = !1 !== c;
                bridge.call("_dsb.returnValue", b);
              });
              a.apply(c, e);
            };
          if (c) h(c, this._dsf);
          else if (d) k(d, this._dsaf);
          else if (((c = a.method.split(".")), !(2 > c.length))) {
            a = c.pop();
            var c = c.join("."),
              d = this._dsf._obs,
              d = d[c] || {},
              f = d[a];
            f && "function" == typeof f
              ? h(f, d)
              : ((d = this._dsaf._obs),
                (d = d[c] || {}),
                (f = d[a]) && "function" == typeof f && k(f, d));
          }
        }
      },
      a;
    for (a in b) window[a] = b[a];
    bridge.register("_hasJavascriptMethod", function(a, b) {
      b = a.split(".");
      if (2 > b.length) return !(!_dsf[b] && !_dsaf[b]);
      a = b.pop();
      b = b.join(".");
      return (b = _dsf._obs[b] || _dsaf._obs[b]) && !!b[a];
    });
  }
})();
export default {
  data() {
    return {
      cateIndex: 0,
      sizeIndex: 0,
      noDataText: false,
      showSort: false,
      sort: 2,
      hiddenShow: false,
      page_size: 10,
      tempName: "",
      pathType: "myCloud",
      noDataTextEmpty: false,
      page: 1,
      isShare: false,
      searchText: lang[this.$route.query.type].zhen_34,
      noData: false,
      cloudData: [],
      tagTime: false,
      noLogin: false,
      mac:"daf3b950-27ee-4d",
      changeList: true,
      cateData: [],
      sizeData: [
        { name: "全部", min: "", max: "" },
        { name: "30以下", min: 0, max: 30 },
        { name: "31-40", min: 31, max: 40 },
        { name: "41-50", min: 41, max: 50 },
        { name: "51-60", min: 51, max: 60 },
        { name: "61-70", min: 61, max: 70 },
        { name: "70以上", min: 70, max: 1000 }
      ],
      sizeIndex: 0,
      noDataCloud: false,
      sortName: lang[this.$route.query.type].zhen_18,
      search: "",
      isMacCode:false,
      isMy:false
    };
  },
  components: {
    selectSort,
    myHead
  },
  watch: {
    "$route.query": function() {
      this.searchType(this.pathType);
      this.isMacCode = false
        this.isMy = false
        this.isMacCode = false
     
    }
  },
  created() {
    // alert(qs.stringify(this.$route.query))
    // alert(location.href.split('?')[1])
    setTimeout(() => {
      document.querySelector('.myhead').style.display = 'block'  
    }, 0);
    this._lang = lang;
    // this.searchType(this.pathType);
    
    window.onscroll = () => {
      if (
        this.getScrollTop() + this.getWindowHeight() >=
        this.getScrollHeight() - 500
      ) {
        this.addSearchType();
      }
    };
  },
  filters: {
    //转化时间年 月 日
    // partFilter: function(value, type) {
    //   if (!value) return "";
    //   var time = value.split("T")[0];
    //   var year = time.split("-");
    //   value = year[0] + "-" + year[1] + "-" + year[2].split(" ")[0];
    //   return value;
    // }
    partFilter: function(value, type) {
      if (!value) return "";
      var date = new Date(value);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d ;
    }
  },
  methods: {
    touchHidden(){
      this.showSort  = false
    },
    base64_encode(str) {
    var c1, c2, c3;
    var base64EncodeChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var i = 0,
      len = str.length,
      string = "";

    while (i < len) {
      c1 = str.charCodeAt(i++) & 0xff;
      if (i == len) {
        string += base64EncodeChars.charAt(c1 >> 2);
        string += base64EncodeChars.charAt((c1 & 0x3) << 4);
        string += "==";
        break;
      }
      c2 = str.charCodeAt(i++);
      if (i == len) {
        string += base64EncodeChars.charAt(c1 >> 2);
        string += base64EncodeChars.charAt(
          ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
        );
        string += base64EncodeChars.charAt((c2 & 0xf) << 2);
        string += "=";
        break;
      }
      c3 = str.charCodeAt(i++);
      string += base64EncodeChars.charAt(c1 >> 2);
      string += base64EncodeChars.charAt(
        ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
      );
      string += base64EncodeChars.charAt(
        ((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6)
      );
      string += base64EncodeChars.charAt(c3 & 0x3f);
    }
    return string;
  },
  getEncry(str){
    let k2 = this.getCode(this.mac); // 对需要加密的数据进行加密
    k2 = this.buf2hex(this.base64ToUint8Array(k2));
    console.log("k2:" + k2);
    console.log("qqqqqqqqqqqqqqqqqq");
    var k3 = this.encrypt(JSON.stringify(str));
    // k3 = this.base64_encode(k3)
    k3 = this.base64ToUint8Array(k3);
    k3 = this.buf2hex(k3);
    var k4 = this.base64_encode("key=" + k2 + "&text=" + k3);
    var k5 = this.stringArrayBuffer(k4);
    var k6 = this.buf2hex(k5);

    let sha256 = jsSha256.sha256; //这里用的是require方法
    var k7 = sha256(k6);
    return k6+','+k7
  },
    getCode(str) {
    //此处操作与后端约定参数
    // 创建RSAKey对象
    let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXRtG/gee0XLO+AGkp3qdI3pkntdB/5ej3DiCD3ZfTv1F1zl37I5ncXIQ9zpK5WEiGTCoVrywclj9etBdecchO2ZMVRT5MBb0EL7FZTdJz93xoAW6ZKbAUS4GBo20aM/7l+3JdX7L/fu/MIvT0GkKoNyTmWCC9VJ8/nKnj4b1uVwIDAQAB`; // ES6 模板字符串 引用 rsa 公钥
    let encryptStr = new JSEncrypt();
    encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    let data = encryptStr.encrypt(str.toString()); // 进行加密
    return data;
  },
  buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return Array.prototype.map
      .call(new Uint8Array(buffer), x => ("00" + x.toString(16)).slice(-2))
      .join("");
  },
  stringArrayBuffer(str) {
    const buffer = new ArrayBuffer(str.length);
    const bytes = new Uint8Array(buffer);

    str.split("").forEach(function(str, i) {
      bytes[i] = str.charCodeAt(0);
    });

    return buffer;
  },
  encrypt(plaintText) {
    const CRYPTOJSKEY = "daf3b950-27ee-4d";
    var plaintText = plaintText;
    var options = {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    };
    var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
    var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
    var encryptedBase64Str = encryptedData.toString().replace(/\//g, "_");
    encryptedBase64Str = encryptedBase64Str.replace(/\+/g, "-");
    return encryptedBase64Str;
  },
   base64ToUint8Array(base64String) {
　　　　const padding = '='.repeat((4 - base64String.length % 4) % 4);
       const base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/');

       const rawData = window.atob(base64);
       const outputArray = new Uint8Array(rawData.length);

       for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
       }
       return outputArray;
},
  _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  },
    closeHidden() {
      this.showSort = false;
      this.hiddenShow = false;
    },
    changeStyle() {
      this.changeList = !this.changeList;
    },
    selectSort(text) {
      window.scrollTo(0, 0);
      this.loadingData = true;
      if(text==3||text==4){
        this.sortName = lang[this.$route.query.type].zhen_18
      }else if(text==1||text==2){
        this.sortName = lang[this.$route.query.type].zhen_20
      }else{
        this.sortName = lang[this.$route.query.type].zhen_19
      }
      this.sort = text;
      this.searchType("myCloud");
      this.showSort = false;
    },
    toCloudback() {
      dsBridge.call("Dlabel.toCloudBack", "");
    },
    openSort() {
      this.showSort = true;
    },
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    //获取文档完整的高度
    getScrollHeight() {
      var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    toLogin() {
      // this.$router.push({name:'search',query:{token:'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyNTA4LCJ1c2VybmFtZSI6IjE0NzE1MzE0NDgzIiwiZXhwIjoxNTY2MjAxODYwLCJlbWFpbCI6bnVsbH0.eh7Z9mOIq1WwZCL6oSR1DgBf8NQx8qvEwnEeHnQtM-o',type:'0'}})
      dsBridge.call("Dlabel.toLogin", "");
    },
    searchType(path) {
      this.pathType = path;
      this.page = 1;
      this.loadingData = false;
      this.noLogin = false;
      this.noData = false;
      this.noDataText = false;

      this.noDataCloud = false;
      
      if (path == "myCloud") {
        this.getCloudData();
        this.loadingData = false;
        this.isShare = false;
        setTimeout(() => {
          document.querySelector(".codeData").style.marginTop = "0.78rem";
          document.querySelector(".codeList").style.marginTop = "0.78rem";
        }, 0);
      } else if (path == "cloudTemplate") {
        this.changeList = true;
        this.showSort = false;
        this.loadingData = false;
        this.getTemplateData();
        this.isShare = false;
        setTimeout(() => {
          document.querySelector(".codeData").style.marginTop = "0rem";
          document.querySelector(".codeList").style.marginTop = "0rem";
        }, 0);
      } else {
        this.changeList = true;
        this.showSort = false;
        this.noDataText = false;
        this.isShare = true;
        setTimeout(() => {
          document.querySelector(".codeData").style.marginTop = "0rem";
          document.querySelector(".codeList").style.marginTop = "0rem";
        }, 0);
      }
    },
    addSearchType() {
      if (this.pathType == "myCloud") {
        this.addCloudData();
        this.isShare = false;
      } else if (this.pathType == "cloudTemplate") {
        this.addTemplateData();
        this.isShare = false;
      } else {
        this.isShare = true;
      }
    },
    feedbackButton() {
      dsBridge.call("Dlabel.clickFeedbackButton", "");
    },
    confirm() {
      this.noDataText = false;
      this.noData = false;
      this.noDataTextEmpty = false;
      this.search = this.tempName;
      this.page = 1;
      this.searchType(this.pathType);
    },

    selectTypeTag(item) {
      if (this.pathType == "cloudTemplate") {
        this.selectTempTag(item);
      } else {
        this.selectTag(item);
      }
    },
    selectTempTag(item) {
      clearTimeout(_tagTime);

      if (this.tagTime) return;
      var _tagTime = setTimeout(() => {
        this.tagTime = false;
      }, 2000);
      this.tagTime = true;
      console.log({
        id: item.id,
        name: item.name,
        file:item.file,
        width: item.fileWidth,
        height: item.fileHeight
      });
      dsBridge.call("Dlabel.getTemplate",{
        id: item.id,
        name: item.name,
        file:item.file,
        width: item.fileWidth,
        height: item.fileHeight
      });
    },
    selectTag(item) {
      clearTimeout(_tagTime);

      if (this.tagTime) return;
      var _tagTime = setTimeout(() => {
        this.tagTime = false;
      }, 1500);
      this.tagTime = true;
      var width = 0,
        height = 0;
      if (item.fileSize) {
        if (item.fileSize.toLowerCase().indexOf("x") != -1) {
          width = item.fileSize.split("x")[0];
          height = item.fileSize.split("x")[1];
        } else {
          width = item.fileSize.split("*")[0];
          height = item.fileSize.split("*")[1];
        }
      }
      console.log({
        id: item.id,
        name: item.name,
        file: item.file,
        width: item.width,
        height: item.height
      });
      dsBridge.call("Dlabel.getUserTemplate", {
        id: item.id,
        name: item.name,
        file: item.file,
        width: item.width,
        height: item.height
      });
    },
    getTemplateData() {
      // this.$indicator.open({
      //   text: "Loading..."
      // });
      this.noDataText = false;
      this.noDataTextEmpty = false;
      var type = this.$route.query.type
      if(type==1){
        type = 2
      }else{
        type = 1
      }
      var tempData = {
        keyWords: this.search,
        pageNo: this.page,
        languageId:type,
        pageSize: this.page_size,
          "equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          "equip": GetQueryString('equip'),
          "reqTime": new Date().getTime(),
          src:2,
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      tempData = this.getEncry(tempData)
      this.cloudData = []
      DlabelTemplateSelect({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]})
        .then(res => {
          if(this.pathType=='cloudTemplate')
            this.cloudData = res.data.data.list;
          this.cloudData = res.data.data.list;
          
          if (this.cloudData.length <= 0) {
            this.loadingData = true;
            this.noData = true;
          } else if (this.cloudData.length < this.page_size) {
            this.loadingData = true;
            this.noDataText = true;
          }
          // this.$indicator.close();
        })
        .catch(err => {

          // this.$indicator.close();
        });
    },
    getCloudData() {
      this.loadingData = true;
      // this.$indicator.open({
      //   text: "Loading..."
      // });
      this.noDataText = false;
      this.noDataTextEmpty = false;
      var tempData = {
        keyWords: this.search,
        pageNo: this.page,
        pageSize: this.page_size,
        type: this.sort,
          "equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          src:2,
          "equip": GetQueryString('equip'),
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      // if(!this.isMacCode)
      //   tempData.macCode = GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      // else{
      //     return
      //   }
      console.log(tempData)
      console.log(tempData)
      tempData = this.getEncry(tempData)
      this.cloudData = []
      if(!GetQueryString('token')||GetQueryString('token').length<10){
        this.loadingData = true
        this.cloudData = []
        this.noLogin = true
        return
      }
      cloundList({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]})
        .then(res => {
          if(res.data.code==5002){
            this.isMacCode = true
            this.isMy = true
            var tempQuery = this.$route.query
            delete tempQuery.macCode
            tempQuery.token = ''
            // this.$router.push({name:'search',query:tempQuery})
            location.href = location.href.split('?')[0] + '?' + qs.stringify(tempQuery)+'&tia=1'
            dsBridge.call("Dlabel.deviceAlreadyLoggedIn",'');
            // return
          }
          // this.$indicator.close();
          this.loadingData = false;
          if (res.data.code == 401 || res.data.code==5002) {
            this.loadingData = true;
            this.cloudData = [];
            this.noLogin = true;
            return;
          }
          if (res.data.data.list.length <= 0 && !this.search) {
            this.noDataTextEmpty = true;
            this.noDataText = false;
          }
          this.page++;
          if(this.pathType=='myCloud')
            this.cloudData = res.data.data.list;
          if (this.cloudData.length <= 0) {
            this.loadingData = true;
            if (this.search) {
              this.noDataCloud = true;
            }
          } else if (this.cloudData.length < this.page_size) {
           
            this.loadingData = true;
          }
        })
        .catch(err => {
          this.loadingData = true;
          // this.$indicator.close();
        });
    },
    addTemplateData() {
      if (this.loadingData) {
        return;
      }
      this.loadingData = true;
      // this.$indicator.open({
      //   text: "Loading..."
      // });
      var type = this.$route.query.type
      if(type==1){
        type = 2
      }else{
        type = 1
      }
      var tempData = {
        keyWords: this.search,
        pageNo: this.page,
        languageId:type,
        pageSize: this.page_size,
          "equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          "equip": GetQueryString('equip'),
          src:2,
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      tempData = this.getEncry(tempData)
      DlabelTemplateSelect({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]})
        .then(res => {
          this.page++;
          if (this.cloudData.length <= 0) {
            this.loadingData = true;

            this.noData = true;
          } else if (res.data.data.list.length < this.page_size) {
            this.loadingData = true;
            this.noDataText = true;
          }
          this.loadingData = false;
          res.data.data.list.forEach(element => {
            this.cloudData.push(element);
          });
          // this.$indicator.close();
        })
        .catch(err => {
          this.loadingData = true;
          // this.$indicator.close();
        });
    },
    addCloudData() {
      if (this.loadingData) {
        return;
      }
      this.loadingData = true;
      // this.$indicator.open({
      //   text: "Loading..."
      // });
      var tempData = {
        keyWords: this.search,
        pageNo: this.page,
        pageSize: this.page_size,
        type: this.sort,
          "equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          "equip": GetQueryString('equip'),
          "reqTime": new Date().getTime(),
          src:2,
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      tempData = this.getEncry(tempData)
      cloundList({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]})
        .then(res => {
          this.page++;
          if (this.cloudData.length <= 0) {
            this.loadingData = true;

            this.noData = true;
          } else if (res.data.data.list.length < this.page_size) {
            this.loadingData = true;
            this.noDataText = true;
          }
          this.loadingData = false;
          // this.$indicator.close();
          res.data.data.list.forEach(element => {
            this.cloudData.push(element);
          });
        })
        .catch(err => {
          // this.$indicator.close();
          this.loadingData = true;
        });
    },
    openSort() {
      this.showSort = true;
    }
  }
};
</script>



